<stb-surface [variant]="background()" [class.has-border]="hasBorder()" [class]="size() + ' ' + customClass()"
  ><ng-content></ng-content
></stb-surface>
